/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@apollo/client'
import {
  ButtonBase,
  IconButton,
  ListItem,
  Menu,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

import { ROLE_DELETE_MUTATION } from '../../graphql/roleMutations'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { RoleBrief } from '../../types/role'
import { canManageRole } from '../RoleManagementForm/roleScope'
import useStyles from './styles/TemplatesTable.styles'

interface RoleRowProps {
  data: RoleBrief
  refetchRolesList: () => void
}

const RoleRow: React.FC<RoleRowProps> = ({ data, refetchRolesList }) => {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)
  const handleMoreIconClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const [deleteRole] = useMutation(ROLE_DELETE_MUTATION, {
    onCompleted: (resp) => {
      toast.success(resp.deleteRole.message)
      refetchRolesList()
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  return (
    <div className={classes.roleRowRoot}>
      <ButtonBase
        className={[
          classes.tableRow,
          isSmallScreen ? classes.tableRowSkeletonForMobile : ''
        ].join(' ')}
        component={LocalizedLink}
        to={`/access-management/role-management/${data.roleID}/edit`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.name}</Typography>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.description}</Typography>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">
            {data.isActive ? getTranslate('Active') : getTranslate('Deactive')}
          </Typography>
        </div>
      </ButtonBase>
      {/* The row still opens the role (read-only when it cannot be changed); only the
          actions IAM would refuse are hidden. */}
      <div hidden={!canManageRole(data.canManage)}>
        <IconButton onClick={handleMoreIconClick}>
          <MoreIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <ListItem
            button
            component={LocalizedLink}
            to={`/access-management/role-management/${data.roleID}/edit`}>
            {getTranslate('Edit')}
          </ListItem>
          <ListItem
            button
            onClick={() => {
              deleteRole({
                variables: {
                  roleID: data.roleID
                }
              })
            }}>
            {getTranslate('Delete Role')}
          </ListItem>
        </Menu>
      </div>
    </div>
  )
}

export default RoleRow
